import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getOptionsQueryParams } from "@app/class/Utilities";
import { formatBytes } from "@app/filters/formatBytes.filter";
import { ISim, SimType } from "@app/interfaces/ISim";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ISimStatus } from "../_models/ISimStatus";
import { ISimQueryOptions } from "../_routes/hardware/_models/ISimQueryOptions";
import { ISimStatusInfo } from "./peripheral.service.ajs";

@Injectable({
    providedIn: 'root'
})
export class SimService {
    constructor(private readonly http: HttpClient) { }

    getSims(options: ISimQueryOptions = {}): Observable<ISim[]> {
        const params = getOptionsQueryParams(options);

        return this.http.get<ISim[]>(`/api/sims/`, params);
    }

    getSim(simId: number): Observable<ISim> {
        return this.getSims({ Id: simId }).pipe(map(sims => {
            if (sims.length) {
                return sims[0];
            }
        }))
    }

    getSimInfo(serial: string): Observable<ISimStatusInfo> {
        return this.http.get<ISimStatusInfo>(`/api/foundation/units/${serial}/simstatus`);
    }

    getSimByIccid(iccid: string): Observable<ISim> {
        return this.getSims({ Iccid: iccid }).pipe(map(sims => {
            if (sims?.length) {
                return sims[0];
            }
        }));
    }

    getSimStatusByIccid(iccid: string, type: SimType): Observable<ISimStatus> {
        return this.http.get<ISimStatus>(`/api/sims/status`, {
            params: {
                iccid,
                type
            }
        }).pipe(map(simStatus => {

            if (simStatus.DataUsage != null) {
                simStatus.dataUsageFormatted = formatBytes()(simStatus.DataUsage);
            }
            return simStatus;
        }))
    }    

    updateSim(sim: ISim): Observable<ISim> {
        return this.http.post<ISim>('/api/sims', sim);
    }
}
